<template>
    <div class="hc-history-card">

        <div class="hc-accent-ribbon"></div>

        <div class="hc-header">
            <div class="hc-date">
                <span class="hc-dot"></span>
                <span class="hc-mono hc-date-text">{{ formatUnixTimestamp(props.time)?.split(' ')[0] }}</span>
            </div>
            <span class="hc-right-texts">
                <div v-if="props.activityStatus == 0 && props.returnTurnover" class="hc-status-badge hc-status-norewards">
                    {{ $t('activityStatus.noRewards') }}
                </div>
                <div v-else-if="props.activityStatus == 0 || props.activityStatus == 11" class="hc-status-badge hc-status-pending">
                    {{ $t('activityStatus.pending') }}
                </div>
                <div v-else-if="props.activityStatus == 1" class="hc-status-badge hc-status-completed">
                    {{ $t('activityStatus.completed') }}
                </div>
                <div v-else-if="props.activityStatus == 2" class="hc-status-badge hc-status-norewards">
                    {{ $t('activityStatus.noRewards') }}
                </div>
                <div v-else-if="props.activityStatus == 3" class="hc-status-badge hc-status-norewards">
                    {{ $t('activity.overdue') }}
                </div>
            </span>
        </div>

        <div class="hc-body">
            <div class="hc-gift-container">
                <img class="hc-gift-icon" src="@/assets/firstRecharge/gitfBoxFR3.png" alt="">
            </div>
            <div class="hc-info">
                <div class="hc-label-main">{{ $t('dayList.giftAmount') }}</div>
                <div class="hc-value-main hc-mono">
                    <span class="hc-currency">R$</span> {{ props.valueOne }}
                </div>
                <div class="hc-turnover-pill">
                    {{ $t('dayList.turnoverTimes') }} <span class="hc-mono">{{ props.valueTwo }}x</span>
                </div>
            </div>
        </div>

        <div class="hc-footer">
            <div class="hc-stat">
                <div class="hc-label-sub">{{ $t('activity.available') }}</div>
                <div class="hc-value-sub hc-mono">{{ formatCurrency(props.availableAmount) }}</div>
            </div>
            <div class="hc-divider"></div>
            <div class="hc-stat">
                <div class="hc-label-sub">{{ $t('activity.givenAmount') }}</div>
                <div class="hc-value-sub hc-mono">{{ formatCurrency(props.givenAmount) }}</div>
            </div>
        </div>

    </div>
</template>

<script setup lang="ts">
import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';

const props = defineProps({
    valueOne: {
        type: Number,
        default: 0
    },
    valueTwo: {
        type: Number,
        default: 0
    },
    time: {
        type: Number,
        default: 0
    },
    activityStatus: {
        type: Number,
        default: 0
    },
    returnTurnover: {
        type: Boolean,
        default: false
    },
    availableAmount: {
        type: Number,
        default: 0
    },
    givenAmount: {
        type: Number,
        default: 0
    }
});
</script>

<style scoped>


.hc-history-card {
    position: relative;
    background-color: #0c1225;
    border: 1px solid #0d2344;
    border-radius: 20px;
    padding: 20px 24px;
    margin-bottom: 12px;
    color: #fff;
    overflow: hidden;
    box-shadow: 0 -5px 12px rgb(52 66 129 / 50%);
}

.hc-accent-ribbon {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(
        1deg,
        transparent 0%,
        #2c4196  30%,
        #2c4196  60%,
        transparent 100%
    );
    border-radius: 20px 20px 0 0;
}

.hc-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px 16px;
    margin: -20px -24px 20px;
    border-bottom: 1px solid rgb(50 187 255 / 10%);
}

.hc-date {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #afc7ea;
}

.hc-dot {
    width: 6px;
    height: 6px;
    background-color: #afc7ea;
    border-radius: 50%;
    flex-shrink: 0;
}

.hc-date-text {
    font-size: 12px;
    letter-spacing: 0.04em;
    color: #afc7ea;
}

.hc-right-texts {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.hc-status-badge {
    padding: 3px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 11px;
    text-align: center;
    white-space: nowrap;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
}

.hc-status-pending {
    background-color: #3264c8;
    border: 1.5px solid #6b9cf6;
    color: #fff;
    box-shadow: 0 2px 5px rgba(0,0,0,0.4), inset 0 0 5px rgba(107, 156, 246, 0.5);
}

.hc-status-completed {
    background-color: #2e8233;
    border: 1.5px solid #6ed174;
    color: #fff;
    box-shadow: 0 2px 5px rgba(0,0,0,0.4), inset 0 0 5px rgba(110, 209, 116, 0.5);
}

.hc-status-norewards {
    background-color: #c42d2d;
    border: 1.5px solid #ff6b6b;
    color: #fff;
    box-shadow: 0 2px 5px rgba(0,0,0,0.4), inset 0 0 5px rgba(255, 107, 107, 0.5);
}

.hc-body {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.hc-gift-container {
    position: relative;
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(32, 139, 232, 0.05);
    border: 1px solid rgba(32, 59, 232, 0.2);
    border-radius: 16px;
    overflow: hidden;
}

.hc-gift-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.35;
    border-radius: 16px;
    z-index: 0;
}

.hc-gift-icon {
    width: 80%;
    position: relative;
    z-index: 1;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5));
}

.hc-info {
    flex: 1;
}

.hc-label-main {
    font-size: 11px;
    font-weight: 500;
    color: #d4e6ffa0;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 6px;
}

.hc-value-main {
    
    font-size: 28px;
    font-weight: 600;
    color: #FFD060;
    line-height: 1;
    letter-spacing: -0.02em;
    margin-bottom: 10px;
}

.hc-currency {
    font-size: 16px;
    margin-right: 2px;
    color: #ffffff98;
}

.hc-turnover-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: 6px;
    font-size: 11px;
    color: #8586c4bd;
}

.hc-turnover-pill .hc-mono {
    color: #94d1f2;
    font-weight: 600;
    background: rgba(32, 55, 232, 0.05);
    border: 1px solid rgba(42, 70, 254, 0.3);
    border-radius: 6px;
    font-size: 11px;
    padding: 3px 10px;
}

.hc-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #080a1a;
    border-top: 1px solid rgba(50, 166, 255, 0.1);
    border-radius: 0 0 12px 12px;
    padding: 14px 24px;
    margin: 0 -24px -20px;
}

.hc-stat {
    flex: 1;
    text-align: center;
}

.hc-label-sub {
    
    font-size: 11px;
    font-weight: 500;
    color: #d3deff85;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 4px;
}

.hc-value-sub {

    font-size: 16px;
    font-weight: 500;
    color: #7071c4;
}

.hc-divider {
    width: 1px;
    height: 28px;
    background: rgba(255, 185, 50, 0.08);
    flex-shrink: 0;
}

.hc-mono {
   
    font-weight: 600;
}

@media (max-width: 380px) {
    .hc-value-main {
        font-size: 22px;
    }
    .hc-gift-container {
        width: 64px;
        height: 64px;
    }
    .hc-status-badge {
        font-size: 10px;
        padding: 2px 8px;
    }
    .hc-header {
        padding: 14px 16px 12px;
        margin: -20px -24px 16px;
    }
    .hc-footer {
        padding: 12px 16px;
        margin: 0 -24px -20px;
    }
}
</style>
